<template>
	<div class="templateManagement">
    <el-dialog
    :title="$t('other.a2938')"
    :visible.sync="dialogVisible"
    width="30%"
    >
    <el-input v-model="productName" :placeholder="$t('other.a2940')"></el-input>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="createModel()">{{$t('other.a279')}}</el-button>
    </span>
    </el-dialog>
    <el-dialog
    :title="$t('other.a2939')"
    :visible.sync="diaTbo"
    width="30%"
    >
   <el-select style="width:250px" ref="searchSelect"    v-model="country"   :placeholder="$t('other.a644')">
    <el-option
    v-for="item in countryOption"
    :key="item.value"
    :label="item.label"
    :value="item.value"
    >
    </el-option>
</el-select>
    <span slot="footer" class="dialog-footer">
        <el-button @click="diaTbo = false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="copyItem()">{{$t('other.a279')}}</el-button>
    </span>
    </el-dialog>
     <div class="first_hader">
        <div class="check_header">
            {{$t('other.a2805')}}
        </div>

        <div >
            <div class="second_header">
                 <div class="block">
                    <el-date-picker
                        v-model="value4"
                        type="datetimerange"
                        size="small"
                        :picker-options="pickerOptions2"
                        :range-separator="$t('other.a47')"
                        :start-placeholder="$t('other.a45')"
                        :end-placeholder="$t('other.a46')"
                        @change="getRecharge()"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        align="right">
                    </el-date-picker>
                </div>
                
                <div>
                </div>
                
            </div>
        
            <div class="third_header">
                <div>
                    <el-checkbox class="third_header_item" @change="target(null)" v-model="checkedAll">{{$t('other.a378')}}/{{$t('other.a706')}}（{{targetList.length}}）</el-checkbox>
            

                    <!-- <el-dropdown  class="third_header_item" >
                    <el-button type="primary">
                        {{$t('other.a2521')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown"  >
                        <el-dropdown-item @click.native="massEditor(item)" v-for="(item,index) in massOptions" :key='index'>{{item.label}}</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown> -->
                    <el-select class="third_header_item" @change="showOrHide()" v-model="siteValue" :placeholder="$t('other.a2941')">
                        <el-option
                        v-for="item in siteOptions"
                        :key="item.value "
                        :label="item.label | capitalize"
                        :value="item.value">
                        </el-option>
                    </el-select>

                    <!-- <el-button v-show="!showBtn"  style="margin:0 10px" type="primary" @click="addItems()">添 加 产 品</el-button> -->
                </div>
              
                <div>
                    <el-button v-show="showBtn"  style="margin:0 10px" type="danger" @click="confirmBtn()">{{$t('other.a2942')}}</el-button>
                    <el-button v-show="showBtn"  style="margin:0 10px" type="danger" @click="goBack()">{{$t('other.a605')}}</el-button>
                </div>
                

                
            </div>
           

      
         
        </div>
    </div>
    
    <div class="order_Box">
          <div v-if="!childrenModel.length" class="no_data">
              <span class="desc">{{$t('other.a1347')}}</span>
              
          </div>
          <div v-else class="item_wrapper" v-for="(item,indexOne) in childrenModel" :key="indexOne">
              <div  class="item_header_wrapper" >
              <div class="item_header">
                  <!-- <span class="header_item" @click="editor(item,0)">{{$t('other.a238')}}</span> -->
                  <span class="header_item" @click="editorCopy(item,0)">{{$t('other.a238')}}</span>
                  <span class="header_item" @click="deleteItemw(item,indexOne)">{{$t('other.a312')}}</span>
                  <span class="header_item" @click="toBack(item,indexOne)" v-if="item.children == ''">{{$t('other.a2943')}}</span>
                 
              </div>
              <div class="main_content">
                  <div class="item_left">
                      <div class="pic_box">
                      <img style="width:100%" :src="item.photoList[0]">
                        </div>
                        <div class="item_name">
                            {{item.productName}}
                        </div>
                  </div>
                   <div class="item_center">
                       <!-- <div>{{$t('other.a1348')}}：{{item.isPreOrder ? $t('other.a191') : $t('other.a192')}}</div> -->
                       <!-- <div>{{$t('other.a1348')}}：{{item.salesStatus}}</div>
                       <div>{{$t('other.a1349')}}:{{item.stock}}</div>
                       <div>{{$t('other.a1350')}}：{{item.sales}}</div> -->
                       <div>{{$t('other.a2944')}}：{{ renderTime(item.createdTime)}}</div>
                       <div>{{$t('other.a1391')}}：{{item.productSku}}</div>
                       <div>{{$t('other.a1260')}}：{{item.productKeyWord}}</div>
                         <div>{{$t('other.a1261')}}：{{item.salesStatus}}</div>
                       <div>{{$t('other.a360')}}：{{ productStatus[item.productStatus]}}</div>
                        <div>{{$t('other.a1262')}}：{{item.purchaseCost}}</div>
                   </div>
                   
                   <div class="item_center">
                       <div>{{$t('other.a1259')}}：{{item.isQualityTest== "is_quality_test" ? $t('other.a1280') : $t('other.a1281')}}</div>
                      
                       <div>{{$t('other.a1395')}}：{{item.productPrincipal}}</div>
                       <div>{{$t('other.a1258')}}：{{item.estimateProfit}}</div>
                         <div>{{$t('other.a1113')}}：{{showsuplier(item.supplier)}}</div>
                       <div>{{$t('other.a1264')}}：{{showStoreName(item.warehouse)}}</div>
                       <!-- <div>商品链接：{{item.productUrl == null?$t('other.a354'): item.productUrl}}</div> -->
                   </div>

                   <div class="item_center">
                       <div class="ontin" @click="publish(item,1)">{{$t('other.a2945')}}shopee</div>
                       <div class="ontin" @click="publish(item,2)">{{$t('other.a2945')}}lazada</div>
                   </div>
                   
                   

              </div>

              <div  v-show="children.country === siteValue || siteValue == 'all'"  class="main_content chilrder_content" v-for="(children,index03) in item.children" :key="index03">
                       <div class="item_center">
                           <div>
                               <div class="desc_item">
                                   <div>
                                    <el-checkbox class="header_item" @change="target(1)" v-model="children.checked02"></el-checkbox>
                                    <span style="padding:0 10px">
                                        <span v-if="children.status == 'DXS'">{{$t('other.a1295')}}</span>
                                        {{children.country | capitalize}}：{{children.productId}}
                                    </span>
                                   </div>
                                </div>
                                <div class="desc_item" v-if="children.status=='DXS'">
                                    <span style="margin:0 5px" v-show="!children.online" class="iconItem_copy"></span>
                                    <span style="margin:0 5px" v-show="children.online" class="iconItem"></span>
                                    <span>{{children.online  ? $t('other.a1353') : $t('other.a1354')}}</span>
                                    
                                </div>
                                <div class="desc_item" v-for="(shopItem,shopIndex) in children.productShops" :key="shopIndex">
                                    <div class="desc_item_first">
                                        <span>{{showCountry(shopItem.shopId,children.country)}}</span>
                                        <span>
                                            <span style="margin:0 5px" v-show="shopItem.publishNum == 0" class="iconItem_copy"></span>
                                            <span style="margin:0 5px" v-show="shopItem.publishNum !== 0" class="iconItem"></span>
                                            <span>{{shopItem.publishNum == 0  ? $t('other.a1354') : $t('other.a1353')}}</span>
                                        </span>
                                    </div>
                                    <!-- <div v-show="shopItem.publishNum !== 0">
                                        <span>商品编码：<span class="item_id" @click="toVeiwId(shopItem)">{{shopItem.itemId ? shopItem.itemId : ''}}</span></span>
                                        <span style="padding:0 10px">{{$t('other.a55')}}：{{shopItem.status ? shopItem.status  : '' | productStatus}}</span>
                                    </div> -->
                                </div>
                           </div>
                           <div>
                               <span class="edito_wrapper" @click="editorChildren(children)">{{$t('other.a238')}}</span>
                               <span class="edito_wrapper" @click="publishProduce(children)">{{$t('other.a1355')}}</span>
                               <span class="edito_wrapper" @click="copyModel(item,children)">{{$t('other.a1356')}}</span>
                               <span class="edito_wrapper" @click="dropdonw(children,indexOne,index03)">{{$t('other.a1292')}}</span>
                               <span class="edito_wrapper" @click="deleteItemwCopy(children,indexOne,index03)">{{$t('other.a312')}}</span>
                                <span class="edito_wrapper" v-if="!children.editorSku" @click="children.editorSku =true,children.numType=children.variations.length">{{$t('other.a93')}}</span>
                                <span class=" changeBox" v-if="children.editorSku" @click="changeItem(children,index03)">{{$t('other.a38')}}</span>
                                <span class=" changeBox" v-if="children.editorSku" @click="children.editorSku =false,children.numType=4">{{$t('other.a146')}}</span>
                           </div>
                       </div>
                    <div class="item_left">
                      <div class="pic_box">
                      <img style="width:100%" :src="children.images[0] ? children.images[0].image : null">
                        </div>
                        <div class="item_name" @dblclick="fixValue(children,children.No)" >
                            <span v-if="!children.editorSku">{{children.name}}</span>
                            <el-input
                            v-else
                            type="textarea"
                            ref="children"
                            :autosize="{ minRows: 2, maxRows: 8}"
                            :placeholder="$t('other.a319')"
                            @blur="saveChildere(children)"
                            v-model="children.name">
                            </el-input>
                        </div>
                    </div>
                   
                  <div class="item_right">
                      <div class="ttp" >
                          <div class="ttp_item">{{$t('other.a335')}}：</div>
                          <div class="ttp_item" v-if="children.tiers[1]">{{$t('other.a1357')}}：</div>
                          <div class="ttp_item">{{$t('other.a310')}}：</div>
                          <div class="ttp_item">{{$t('other.a1275')}}：</div>
                      </div>
                      <div class="ttp" @dblclick="editorSku(children)" v-show="children.variations.length && index09 < children.numType" v-for="(ttp,index09) in children.variations" :key="index09">
                          <div class="ttp_item" v-if="children.tiers[1]">
                              <div v-if="!children.editorSku && children.tiers.length">{{children.tiers[0].optionArray[ttp.tierIndex[0]]}}</div>
                              <div v-else><el-input type="text" v-model="children.tiers[0].optionArray[ttp.tierIndex[0]]"></el-input></div>
                          </div>
                          <div class="ttp_item" v-if="children.tiers[1]">
                              <div v-if="!children.editorSku"> {{children.tiers[1].optionArray[ttp.tierIndex[1]]}}</div>
                              <div v-else><el-input type="text" v-model="children.tiers[1].optionArray[ttp.tierIndex[1]]"></el-input></div>
                          </div>
                          <div class="ttp_item">
                            <div v-if="!children.editorSku">{{children.variations.length ? ttp.stock : children.itemSku}}</div>
                            <div v-else><el-input type="text" v-model="ttp.stock"></el-input></div>
                          </div>

                         <div class="ttp_item">
                            <div v-if="!children.editorSku">{{children.variations.length ? ttp.price : children.itemSku}}</div>
                            <div v-else><el-input type="text" v-model="ttp.price"></el-input></div>
                         </div>
                      </div>
                      <div class="ttp" v-show="!children.variations.length" >
                          <div v-if="!children.editorSku" class="ttp_item">{{children.itemSku}}</div>
                          <div v-else><el-input type="text" v-model="children.itemSku"></el-input></div>
                       
                          <div v-if="!children.editorSku" class="ttp_item">{{children.stock}}</div>
                          <div v-else><el-input type="text" v-model="children.stock"></el-input></div>
                          <div v-if="!children.editorSku"  class="ttp_item">{{children.price}}</div>
                          <div v-else><el-input type="text" v-model="children.price"></el-input></div>
                      </div>
                      <div style="text-align:center;color:#409EFF;cursor: pointer;" v-show="children.numType ==4 && children.variations.length > 4" @click="children.numType= children.variations.length "> 
                          {{$t('other.a1197')}} （{{$t('other.a1199')}}{{children.variations.length-4}}{{$t('other.a1337')}}sku）
                      </div>
                      <div style="text-align:center;color:#409EFF;cursor: pointer;" v-show="children.numType !== 4  && children.variations.length" @click="children.numType= 4 "> 
                        {{$t('other.a1358')}}
                      </div>
                     
                  </div>
              </div>
          
              </div>
          

          </div>
          
    </div>      

		
    <!-- 分页器 -->
    <!-- <div  class="Pager">
        <el-pagination
            @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage1"
        :page-sizes="[15, 20, 30, 50]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="goodsTotal">
        </el-pagination>
    </div> -->
	</div>
</template>

<script>
	import api from '../../../api/api'
	import utils from  '../../../utils/utils.js'
    import md5 from 'js-md5'
    import { mapState, mapMutations } from 'vuex'
import i18n from '@/i18n/i18n'

	export default {
		data() {
			return {
                productStatus:{
        "AUDITED":this.$t('other.a1407'),
        
        "CREATED":this.$t("other.a848")
      }, 
                 productSearchDTO :{
          endTime: "",
          pageNum:1,
          pageSize:50,
          productName: "",
          productStatus:"AUDITED",
          skuName: "",
          startTime: "",
          supplier: "",
          userId:JSON.parse(localStorage.getItem('userInfo')).userId,
          wareHouse: ""
        },
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
				userShopslazada:JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
                NumType:4,
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
                shopOptions:[],
                productUrl:'',
                activeName2:'first',
                siteOptions:[],
                dialogVisible:false,
                productName:'',
                countryOption:[],
                country:null,
                mainitem:null,
                diaTbo:false,
                checkedAll:false,
                showBtn:false,
                siteValue:'all',
                modelId:'',
                options:[],
                massOptions:[{
                    label:this.$t('other.a2934'),
                    value:'1'
                },{
                    label:this.$t('other.a1242'),
                    value:'2'
                },{
                    label:this.$t('other.a2937'),
                    value:'3'
                },{
                    label:this.$t('other.a2903'),
                    value:'4'
                },{
                    label:this.$t('other.a85'),
                    value:'5'
                },],
                fixAttribute:'',
                value4:[],
                childrenModel:[],
                targetList:[],
                supplierData:[],
                getDataList:{
                    end:null,
                    name:null,
                    offset:15,
                    page:0,
                    shopIds:null,
                    start:null,
                    userId:JSON.parse(localStorage.getItem('userInfo')).userId

                },
                   pickerOptions2: {
                    shortcuts: [{
                    text: this.$t("other.a130"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: this.$t("other.a131"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: this.$t("other.a132"),
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                    }]
                },
				
			}
		},
	
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
			}),

		},
		watch:{
          
		},
        filters:{
            capitalize(country){
                const obj={
                    'all':i18n.t('other.a1408'),
                    'TH':i18n.t('other.a1305'),
                    'PH':i18n.t('other.a1306'),
                    'ID':i18n.t('other.a1307'),
                    'MY':i18n.t('other.a1308'),
                    'VN':i18n.t('other.a1310'),
                    'DXS':i18n.t('other.a406')

                }

                return obj[country]
            },
            productStatus(country){
                const obj={
                    'UNLIST':i18n.t('other.a1292'),
                    'NOMAL':i18n.t('other.a1291'),

                }

                return obj[country]
            },
        },
		created(){
            this.init()
            this.getUserSuplist()
            // this.search();
		},
		methods: {

            ...mapMutations("common", [
                "SET_REGISTOR_FALSE",
                'SWITCH_LANG',
            ]),

            publish(item,num){
                console.log(item)
                item.productId=item.template
               
                
                if(!item.productId){
                    this.$message.warning(this.$t('other.a2946'))
                    
                }else{
                    let router
                    if(num == 1){
                    router = this.$router.resolve({ 
                        name: "publishShopee" ,
                        query:{
                        id:item.productId,
                        from:'/hasAgent' 
                        }
                    })
                    }else if(num == 2){
                    router = this.$router.resolve({ 
                        name: "publishLazada" ,
                        query:{
                        id:item.productId,
                        from:'/hasAgent',
                        }
                    })

                    }else if(num == 3){
                    router = this.$router.resolve({ 
                        name: "publishTikTok" ,
                        query:{
                        id:item.productId,
                        from:'/hasAgent' 
                        }
                    })
                    }

                    window.open(router.href, '_blank');
                    
                    
                }
                },



             renderTime(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
    },
    getUserSuplist() {
      api
        .getsuplist({
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
              let arrnew = res.productSuppliers.map((item, index) => {
                    return Object.assign(
                      {},
                      {
                        value : item.id,
                        label : item.supplier
                      }
                    );
                  });
              console.log(arrnew)
            //   this.groupsData = arrnew;
            this.supplierData = arrnew;
            
          } else {
            this.$message.warning(res.msg);
          }
        });
    }, //获取用户的供应商
             showsuplier(id){
        let stores = this.supplierData
        let ttp=null
		if(stores){
			stores.forEach(p => {
				if(p.value == id){
					ttp=p.label
				}
			})
		}

		return ttp ? ttp : this.$t("other.a354")
    },
     showStoreName(id){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
		let ttp=null
		if(stores){
			stores.forEach(p => {
				if(p.storeId == id){
					ttp=p.storeName
				}
			})
		}

		return ttp ? ttp : this.$t("other.a354")
	},
            search() {
        
        
                api
                    .searchproduct(this.productSearchDTO)
                    .then((res) => {
                    console.log(res);
                    if (res.code == "ok") {
                       console.log('获取用户模版信息',res.productList)
                        let site=[]
                        // res.data.models.forEach(p => {
                        //     p.checked01=false
                        //     p.products.forEach(k => {
                        //         k.checked02=false
                        //         k.children.forEach(j => {
                        //             j.checked03=false
                        //             site.push(j.country)
                        //         })
                        //     })
                        // })
                       
                          res.productList.forEach(p => {
                              
                            p.checked01=false
                            p.children.forEach((k,index) => {
                                // k.tiers[0].optionArray = k.tiers[0].optionArray ? k.tiers[0].optionArray : []
                              
                                k.No=Math.random().toString(36).substr(2,4);
                                k.checked02=false
                                k.numType=4,
                                k.isEditor=false
                                k.editorSku=false
                                if(k.items){
                                    k.productShops.forEach(i => {
                                       let obj=k.items.find(item => item.shopid === i.shopId)
                                       if(obj){
                                           i.itemId=obj.itemId
                                           i.status=obj.status
                                       }
                                    })
                                }
                               site.push(k.country)
                            })
                        })


                        site=[...new Set(site)]
                        this.siteOptions=site.map(p => {
                            return {
                                label:p,
                                value:p
                            }
                        })
                        this.siteOptions.unshift({
                            label:'all',
                            value:'all'
                        })
                        console.log(site)
                        // console.log(res.data)
                        this.childrenModel=res.productList
                    } else {
                        this.$message.warning(res.msg);
                    }
                    });
                }, //搜索产品
            scrapeItem(){
               
                let host=this.productUrl.substring(0, this.productUrl.indexOf('/', 8) + 1)+'api/v2/item/get'
                let list=this.productUrl.slice(this.productUrl.indexOf('-i')+3).split('.')
                let matchId="itemid=" +list[1]+ '&' + "shopid=" + list[0]
	            let if_match_="55b03-" + md5.hex("55b03" + md5.hex(matchId) + "55b03")

                api
                .scrapedProdcutItem({
                    itemid:list[1],
                    shopid:list[0],
                    url:host,
                    if_match:if_match_
                })
                .then(res => {
                    console.log('链接采集',res)
                })
                console.log(this.productUrl)   
                console.log(list)
                console.log(host)
                
               
            },


            handleClick(tab, event) {
                console.log(tab, event);
               console.log(this.activeName2)
            },

            

            fixValue(item,index){
                console.log(index)
                console.log(item.isEditor)
                item.isEditor=true
                setTimeout(() => {
                   console.log(this.$refs.children[0])
                   this.$refs.children[0].focus()
                   
                },500)
            },

            editorSku(item,index){
                console.log(index)
                console.log(item.isEditor)
                item.editorSku=true
                // setTimeout(() => {
                //    console.log(this.$refs.children[0])
                //    this.$refs.children[0].focus()
                   
                // },500)
            },

            changeItem(item,index){
                console.log(index)
               
                item.numType=4
               item.editorSku=false
                 console.log(item)
                api
                .updataProduct(item)
                .then(res => {
                    if(res.code === 200){
                       
                        this.$message.success(this.$t('other.a1414'))
                       
                    }else{
                        this.$message.warning(res.msg)
                        
                    }
                }) 
            },

            KVKNG(params){
                api
                .publishProductToDXS(params)
                .then(res => {
                    if(res.code === 200){
                       this.$message.success(this.$t('other.a1303'))
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
            },



            publishProduce(item){
                console.log(item)
                let text=item.status == 'DXS' ? this.$t('other.a1415') : this.$t('other.a1313') 
                this.$confirm(text,this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    if(item.status == 'DXS'){
                        this.KVKNG({
                            productId:item.productId,
                            userId:this.userId,
                            online:true
                        })
                    }else{
                        api
                        .publishProducts({
                            productId:item.productId,
                            userId:this.userId
                        })
                        .then(res => {
                            if(res.code === 200){
                                let falge=false
                                 res.data.forEach(p => {
                                    this.$message.success(p.msg)
                                    if(p.msg.indexOf('上架成功') > -1) {
                                        falge=true
                                    }
                                    
                                })
    
                                if(falge){
                                    // this.getParenMoel()
                                    this.search();
                                }
                            }else{
                                this.$message.warning(res.msg)
                            }
                        })
                    }


                    

                })
            },

            toVeiwId(item){
                console.log(item)
                this.$router.push({
                    path:'/mygoods/shopee',
                    query:{
                        id:item.itemId,
                        status:item.status
                    }
                })
            },

            
            getModelDetail(){
                console.log(this.modelId)
                api
                .getUserProductModel({modelId:this.modelId})
                .then(res => {
                    if(res.code === 200) {
                        console.log('modelId',res.data)
                        this.childrenModel=res.data.models
                       
                       
                    }
                })
            },

            comfrim(){
                let obj=this.mygoodslist.find(item => item.checked)
                console.log(obj.itemId)
                this.$router.push({path:'/productModel',query:{itemId:obj.itemId}})
            },
            target(index){
                console.log(index)
                if(!index){
                   
                     this.childrenModel.forEach(p => {
                        p.children.forEach(k => {
                           k.checked02=!k.checked02
                           
                        })
                      })


                }
               let list=[]
                this.childrenModel.forEach(p => {
                    p.children.forEach(k => {
                        list.push(k)
                    })
                })
                this.targetList=list.filter(p => {
                    return p.checked02===true
                })
                console.log('99',this.targetList)
                
            
                
            },

            
             addItems(item){
                this.$router.push({path:'/productModel'})
            },

            confirmBtn(){
                console.log(this.$route.query.flag)
                if(!this.targetList.length){
                    this.$message.warning(this.$t('other.a1416'))
                    return
                }
                if(this.$route.query.flag == 'storeItemDetail'){
                     this.$router.push({
                        path:'/storeItemDetail',
                        query:{
                            productId:this.targetList[0].productId,
                            groupId:this.$route.query.groupId,
                            storeId:this.$route.query.storeId
    
                        }
                    })

                }else{

                    this.$router.push({
                        path:'/alliance/singleGoods',
                        query:{
                            productId:this.targetList[0].productId,
                            groupId:this.$route.query.groupId,
                            storeId:this.$route.query.storeId
    
                        }
                    })
                }
            },

            editor(item){
                api
                .getProductByproductId(
                    {
                        productId  : item.template,
                    }
                )
                .then(res => {
                    if(res.code === 200){
                      this.SET_REGISTOR_FALSE(res.data)
            
                this.$router.push({path:'/productModel',query:{addOthers:JSON.stringify(true),idModel:item.template}})
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
               console.log(item)  
            },

            editorCopy(item){
                api
                .getProductByproductId(
                    {
                        productId  : item.template,
                    }
                )
                .then(res => {
                    if(res.code === 200){
                      this.SET_REGISTOR_FALSE(res.data)
            
                this.$router.push({path:'/factorysupply/productShelves',query:{addOthers:JSON.stringify(true),idModel:item.template}})
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
               console.log(item)  
            },

            editorChildren(item){
                this.SET_REGISTOR_FALSE(item)
                this.$router.push({path:'/factorysupply/productShelves',query:{
                    productId:JSON.stringify(item.productId),
                    country:JSON.stringify(item.country)
                }})
                console.log(item)
            },

            massEditor(item){
                console.log(item)
                this.SWITCH_LANG(this.targetList)
                let list=this.targetList.map(p => {
                    return p.productId
                })
                console.log(list)
                this.$router.push({
                    path:'/templateEditor',
                    query:{
                        lebel:JSON.stringify(item.value)
                    }
                })
            },

            createModel(){
                api
                .createProductModel({
                    modelName:this.productName,
                    userId:this.userId
                })
                .then(res => {
                    if(res.code === 200){
                        this.$message.success(this.$t('other.a1315'))
                        console.log('创建的模版',res.data)
                        // this.getParenMoel()
                        this.search();
                        this.dialogVisible=false

                    }
                })
            },
            deleteItemw(row,index){
                let arr = [];
      arr.push(row.productId)
      let obj ={
        productIds:arr,
        userId : this.userId
      }
      this.$confirm(this.$t('other.a608'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                      api
        .deleteproduct(obj)
        .then((res) => {
          console.log(res);
          if (res.code == "ok") {
            this.$message.success(this.$t('other.a1232'));
            this.search();
          } else {
            this.$message.warning(res.msg);
          }
        });
                })
            },
            toBack(row,index){
                api
                          .auditproducts({
                            productLibraryId : row.productId,
                            productStatus : "CREATED"
                          })
                          .then((res) => {
                            console.log(res);
                            if (res.code == "ok") {
                                this.$message.success(this.$t('other.a2947'))
                                this.search();
                            } else {
                              this.$message.warning(res.msg);
                            }
                          });
            },
            // deleteItemw(item,indexOne){
            //     this.$confirm(this.$t('other.a608'),this.$t("other.a142"),{
            //         confirmButtonText:this.$t('other.a145'),
            //         cancelButtonText: this.$t('other.a146'),
            //         type: 'warning'
            //     }).then(() => {
            //         console.log(item)
            //         api
            //         .deleteChildrenMoadel(item)
            //         .then(res => {
            //             if(res.code === 200){
            //                 this.$message.success(this.$t('other.a565'))
                        
            //                 this.childrenModel.splice(indexOne,1)
            //             }
            //         })
            //     })
            // },

            dropdonw(item,index,index01){
                console.log(item)
                let params={
                    productId:item.productId,
                    userId:this.userId,
                    online:false
                }
                api
                .publishProductToDXS(params)
                .then(res => {
                    if(res.code === 200){
                       this.$message.success(this.$t('other.a1417'))
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
            },

            deleteItemwCopy(item,indexOne,index){
                console.log(item,indexOne,index)
                this.$confirm(this.$t('other.a608'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    console.log(item)
                    api
                    .deleteChildrenMoadel(item)
                    .then(res => {
                        if(res.code === 200){
                            this.$message.success(this.$t('other.a565'))
                            this.init()
                        }
                    })
                })
            },

            
            saveChildere(item){
                item.isEditor=false
                item.editorSku=false
                 api
                .updataProduct(item)
                .then(res => {
                    if(res.code === 200){
                       
                        this.$message.success(this.$t('other.a1414'))
                       
                    }else{
                        this.$message.warning(res.msg)
                        
                    }
                })
            },

            copyItem(){
                this.mainitem.country=this.country

                 let itemCopy=JSON.parse(JSON.stringify(this.mainitem))
                itemCopy.productId=null
                itemCopy.items=[]
                itemCopy.productShops.forEach(p => {
                    p.publishNum=0
                })
                    console.log(itemCopy)
                    api
                .updataProduct(itemCopy)
                .then(res => {
                    if(res.code === 200){
                        this.$message.success(this.$t('other.a1418'))
                        this.diaTbo=false
                        // this.getParenMoel()
                        this.search();
                    }else{
                        this.$message.warning(res.msg)
                        
                    }
                })
                console.log(this.mainitem)
            },
            
            copyModel(item,children){
                console.log(item,children)
                if(children.status == 'DXS'){
                    this.diaTbo=true
                    this.mainitem=JSON.parse(JSON.stringify(children))
                }else{

                    let itemCopy=JSON.parse(JSON.stringify(children))
                    itemCopy.productId=null
                    itemCopy.items=[]
                    itemCopy.productShops.forEach(p => {
                        p.publishNum=0
                    })
                     console.log(itemCopy)
                     api
                    .updataProduct(itemCopy)
                    .then(res => {
                        if(res.code === 200){
                            console.log('复制成功！',res.data)
                            res.data.editorSku=false
                            this.$message.success(this.$t('other.a1418'))
                            this.search()
                            item.children.push(res.data)
                        }else{
                            this.$message.warning(res.msg)
                            
                        }
                    })
                }
            },

            deleteParentModel(item,indexOne){
                 this.$confirm(this.$t('other.a1419'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    console.log(item)
                    api
                    .deleteParentMoadel(item)
                    .then(res => {
                        if(res.code === 200){
                            this.$message.success(this.$t('other.a565'))
                            setTimeout(() =>{
                                this.childrenModel.splice(indexOne,1)
                            },500)
                        }
                    })
                })
            },

            goBack(){
                if(this.$route.query.obj == '/distributeProduct/hasAgent'){
                       this.$router.push({
                           path:'/storeItemDetail',
                           query:{
                               obj:this.$route.query.obj
                           }
                       })
                      
                }
            },
			init(){
				
                    this.value4=[utils.getRecentSevenDay(-30),utils.getRecentSevenDay(1)]
                    this.countryOption=utils.getCountryOption()
                    this.getDataList.start=this.value4[0]
                    this.getDataList.end=this.value4[1]
                    this.search();
                    if(this.$route.query.flag == 'bindModelFromalliance'){
                        this.showBtn=true
                        this.$message.warning(this.$t('other.a2948'))
                    }

                    if(this.$route.query.obj == '/distributeProduct/hasAgent'){
                        this.showBtn=true
                      
                    }


					
					
				
			},

            showOrHide(){
                console.log(this.childrenModel,this.siteValue)
            },

            getParenMoel(){
                 api
                .getUserProduct(this.getDataList)
                .then(res => {
                    if(res.code === 200) {
                        console.log('获取用户模版信息',res.data)
                        let site=[]
                        // res.data.models.forEach(p => {
                        //     p.checked01=false
                        //     p.products.forEach(k => {
                        //         k.checked02=false
                        //         k.children.forEach(j => {
                        //             j.checked03=false
                        //             site.push(j.country)
                        //         })
                        //     })
                        // })
                       
                          res.data.products.forEach(p => {
                              
                            p.checked01=false
                            p.children.forEach((k,index) => {
                              
                                k.No=Math.random().toString(36).substr(2,4);
                                k.checked02=false
                                k.numType=4,
                                k.isEditor=false
                                k.editorSku=false
                                if(k.items){
                                    k.productShops.forEach(i => {
                                       let obj=k.items.find(item => item.shopid === i.shopId)
                                       if(obj){
                                           i.itemId=obj.itemId
                                           i.status=obj.status
                                       }
                                    })
                                }
                               site.push(k.country)
                            })
                        })


                        site=[...new Set(site)]
                        this.siteOptions=site.map(p => {
                            return {
                                label:p,
                                value:p
                            }
                        })
                        this.siteOptions.unshift({
                            label:'all',
                            value:'all'
                        })
                        console.log(site)
                        console.log(res.data)
                        this.childrenModel=res.data.products
                    }
                })
            },
			

		
	
			//获取导入商品页面的数据
			getShopItems01() {
				this.getDataList.categoryIds=this.chooseParams.length == 1  ? null : this.chooseParams
				this.getDataList.offset=this.offset
				this.getDataList.page=this.currentPage
				this.getDataList.userId=this.userId
				this.getDataList.shopIds= [this.chooseParams[0]]
				this.getDataList.status=this.productStatua
				this.getDataList.itemName=''

				this.getShopAllItems(this.getDataList)
			},


            showCountry(id,conutry){

                let name= utils.showshopNameByshopIdOne(id)
            

                return name
            },

		

		
	

			
			
			//控制每页显示订单条数
			handleSizeChange(val) {
							 console.log(`每页 ${val} 条`);
							 this.offset=parseInt(`${val}`)
							 this.getDataList.offset=parseInt(`${val}`)
							 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
						this.currentPage=(parseInt(`${val}`) -1) * this.offset
						this.getDataList.page=this.currentPage
						 this.getShopAllItems(this.getDataList)
						 this.currentPage=0
			  },

              getTime(item){
                  return utils.renderTime(item)
              },


   
		
	


		}
	}
</script>

<style lang="scss" scoped>
.templateManagement{
    box-sizing: border-box;
    min-height: 100vh;
    padding: 0 20px;
    padding-bottom: 60px;
    background-color: #eee;

    .first_hader{
        position: fixed;
        top: 50px;
        left:205px;
        width: 86%;
        background-color: #fff;
        padding: 15px 10px;
        box-shadow:  0 2px 1px -1px rgba(0,0,0,0.2);
        z-index: 9;

        /deep/ .el-textarea__inner{
            line-height: 2.5;
        }
        .scrpedProduct{
            width: 97%;
            position: relative;

            .second_box{
                padding:5px 0;
                color: rgba(0,0,0,.65);
            }

            .extension_box{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-content: center;
            }
       

            .dash::after{
                content: '-----------';
                color: #F56C6C;
            }

            .second_wrapper{
                box-sizing: border-box;
                padding: 10px;
                border: 1px solid #909399;
                border-radius: 5px;
            }
       
            
            .extension{
                color: #F56C6C;
                font-size: 30px;
                text-align: center;
                padding:5px 0
            }
        }

        .btn_box{
            position: absolute;
            right: 0;
            bottom: 0;
        }

        .check_header{
            margin-bottom: 15px;
        }

        .second_header{
            display: flex;
            
        }

        .third_header{
            margin-top: 15px;
            display: flex;
            padding-right:20px;
            justify-content: space-between;

            .third_header_item{
                padding:0 10px
            }
        }
    }

  

    .order_Box{
        margin-top: 160px;
        position: relative;

        .no_data{
            width: 100%;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            text-align: center;
            margin-top: 200px;


            .desc{
                font-size: 18px;
                padding: 0 10px;
            }
        }


        .item_wrapper{
        
        margin-bottom: 20px;
        box-shadow: 0 2px 1px -1px rgba(0,0,0,0.2);
        background-color: #fff;

        .nodata{
            text-align: center;
            padding: 30px 0;
        }

        .parent_item{
            height: 50px;
            line-height: 50px;
            font-size: 22px;
            border-bottom: 1px #eee solid;
            display: flex;
            justify-content: space-between;

            .parent_desc{
                margin-left: 25px;
                padding: 0 10px;
                font-size: 16px;
                color: #409eff;
                cursor: pointer;
            }
        }

        .item_header_wrapper{
          box-sizing: border-box;
          padding: 5px 10px;
          margin: 10px;
         
        }

        .item_header{
        height: 30px;
        // border-bottom: 1px solid #efefef;
        line-height: 30px;
        font-size: 20px;
        padding: 5px 10px;
        color:#409eff ;
        cursor: pointer;

        .header_item{
            margin-right: 15px;
            // font-weight: bold;
        }
        }


        .chilrder_content{
            border: 5px solid #eee;
           
            margin: 0 15px;
        }

        

        .main_content{
            box-sizing: border-box;
           
            margin: 10px 0;
            display: flex;
            border: 3px solid #eee;
          
           

            .pic_box{
             width: 80px;
             height: 80px;
        
            }

            .item_left{
                width: 30%;
                display: flex;
                border-right: 3px solid #efefef;

                .item_name{
                   box-sizing: border-box;
                    padding:0 10px;
                    flex: 1;
                }
            }

         

               


                 .item_center{
                        width: 24%;
                        border-right: 3px solid #efefef;
                        padding: 0 10px;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;

                        .ontin{
                            font-size: 18px;
                            font-weight: bold;
                            cursor: pointer;
                            margin: 10px 0;
                        }


                        .desc_item{
                            padding: 5px 0;

                            .desc_item_first{
                                display: flex;
                                justify-content: space-between;
                            }

                            .item_id{
                                cursor: pointer;
                                color: #409eff;
                            }
                          

                            .copy_item{
                                cursor: pointer;
                                color: #409eff;
                            }

                            .iconItem{
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                vertical-align: middle;
                                background-color: #00c853;
                            }

                            .iconItem_copy{
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                margin: 0 5px;
                                vertical-align: middle;
                                background-color: #616161;
                            }
                        }

                        .edito_wrapper{
                            margin:0 5px;
                            color:#409eff;
                            cursor: pointer;
                            // font-weight: bold;
                        }

                        .changeBox{
                            margin:0 5px;
                            color:#F56C6C;
                            cursor: pointer;
                            // font-weight: bold;
                        }
                    }

            

           

            .item_right{
                flex:1;
                margin: 0 10px;

                .btn{
                    display: flex;
                    justify-content: flex-end;
                }
                .ttp{
                    display: flex;
                    justify-content: flex-start;
                    border-bottom: 3px solid #efefef;
                    margin: 4px 0;

                    .ttp_item:nth-child(1){
                        width: 30%;
                        border-right: 3px solid #efefef;
                       
                    }

                    .ttp_item:nth-child(2){
                        width: 30%;
                        border-right: 3px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(3){
                        width: 20%;
                        border-right: 3px solid #efefef;
                         padding-left: 10px;
                    }

                    .ttp_item:nth-child(4){
                        width: 20%;
                         padding-left: 10px;
                    }
                }
            }
        }

    }


    }

     /deep/ .el-checkbox__inner {
    width: 20px;
    height: 20px;
  }
  /deep/ .el-tabs--card{
      width: 97%;
      box-shadow:none!important;
  }

  /deep/ .el-checkbox__inner::after {
    height: 10px;
    left: 7px;
    width: 4px;
    font-weight: bold;
  }


  /deep/ .el-checkbox__label{
      font-size: 20px;

  }

  
   

    .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

}

	
	

</style>
